import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Set Pages
import { AvailableOrdersComponent } from './available-orders/available-orders.component';
import { OrderInProgressComponent } from './order-in-progress/order-in-progress.component';
import { SubmissionsComponent } from './submissions/submissions.component';
import { CompletedOrdersComponent } from './completed-orders/completed-orders.component';
import { ViewRevisionsComponent } from './view-revisions/view-revisions.component';
import { WritersStatisticsComponent } from './writers-statistics/writers-statistics.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';

const routes: Routes = [
  { path: 'available-orders',                     component: AvailableOrdersComponent   },
  { path: 'order-in-progress',                    component: OrderInProgressComponent   },
  { path: 'submissions',                          component: SubmissionsComponent       },
  { path: 'completed-orders',                     component: CompletedOrdersComponent   },
  { path: 'view-revisions',                       component: ViewRevisionsComponent     },
  { path: 'writers-statistics',                   component: WritersStatisticsComponent },
  { path: 'payment-history',                      component: PaymentHistoryComponent    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WritersRoutingModule { }
